/*
 * Scrolls to hash element if present in url.
 */
var scrollToHash = function scrollToHash(passHash) {
  var hash = passHash ? passHash : window.location.hash;
  var target = false;

  try {
    target = hash ? document.querySelector(hash) : false;
  } catch (_unused) {
    return 0;
  }

  if (hash && target) {
    var rect = target.getBoundingClientRect();
    var scrollTo = parseInt(rect.top + window.scrollY - 80, 10);
    window.scrollTo({
      top: scrollTo,
      behavior: 'smooth'
    });
    return scrollTo;
  }

  return 0;
};

export default scrollToHash;